import React from 'react';
import { Link } from 'react-router-dom';
import './Features.css';

const Features = () => {
  return (
    <section id="features" className="features">
      <h2>Nos formules d&apos;abonnement</h2>
      <p>Directeur, assistante administrative, commercial,... quel que soit votre profil, partagez un seul et même espace collaboratif sécurisé.</p>
      <div className="features-cards-content">
        <div className="features-card">
          <div className="features-card-header">
            <h3>Super</h3>
          </div>
          <div className="features-card-body">
            <ul style={{ textAlign: 'left' }}>
              <li>1 administrateur pour la création et la gestion des autres utilisateurs.</li>
              <li>Téléchargement au format PDF des documents créés et saisis.</li>
              <li>Édition des documents (CERFA), mandat, cession, déclaration d&apos;achat, demande d&apos;immatriculation.</li>
              <li>Accompagnement prise en main et formation.</li>
              <li>SAV.</li>
            </ul>
          </div>
        </div>

        <div className="features-card">
          <div className="features-card-header">
            <h3>Maxi</h3>
          </div>
          <div className="features-card-body">
            <ul style={{ textAlign: 'left' }}>
              <li>1 administrateur pour la création et la gestion des autres utilisateurs.</li>
              <li>Téléchargement au format PDF des documents créés et saisis.</li>
              <li>Édition des documents (CERFA), mandat, cession, déclaration d&apos;achat, demande d&apos;immatriculation, checklist.</li>
              <li>Édition des documents internes (ex : étiquette clé, contrat de prêt, fiche de réception, bon de préparation, confirmation de commande, décharge, ...).</li>
              <li>Accompagnement prise en main et formation.</li>
              <li>SAV.</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="features-buttons">
        <Link to="/contact" className="features-button">Je m&apos;abonne</Link>
      </div>
    </section>
  );
};

export default Features;